<template lang="pug">
h2 Icons
ul
	li(v-for="{ name } in icons")
		VIcon(:name="name")
		.name {{ name }}
</template>

<script lang="ts">
import { defineComponent } from "vue";

import icons from "@/assets/icons.json";

export default defineComponent({
	computed: {
		icons() {
			console.log(icons);
			return Object.keys(icons).map((name) => {
				return {
					name
				};
			});
		}
	}
});
</script>

<style lang="scss" scoped>
ul {
	--icon-size: 50px;

	display: grid;
	gap: 20px;
	grid-template-columns: repeat(4, 1fr);

	list-style: none;
}

li {
	display: block;
	overflow: hidden;
	position: relative;
	padding-bottom: 20px;

	.icon {
		display: block;
		margin: 0 auto 10px;
	}

	.name {
		width: 100%;
		display: block;
		overflow: hidden;
		text-align: center;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
